import $ from "jquery"
import _ from "underscore"
import MoveToDialog from "../MoveToDialog"
import ProjectPanelHeader from "./ProjectPanelHeader"
import ProjectPanelContent from "./ProjectPanelContent"
import LoadingContainer from "../../util/LoadingContainer"
import AssignedUsersEditor from "../usersAssignedToHierarchy/AssignedUsersEditor"
import messageResource from "../../messageResource"
import AssignedUsersEditorContainer from "../usersAssignedToHierarchy/AssignedUsersEditorContainer"
import {applyDataToAssignedUsersEditor} from "../applyAction"
import DeleteProjectPopupConfirmationDialog from "../../cptManagement/deleteConfirmationDialog/DeleteProjectPopupConfirmationDialog"
import ArchiveProjectDialog from "../ArchiveProjectDialog"
import TemplateView from "../../TemplateView"
import ScrollableContainer from '../../util/ScrollableContainer'
import CommentsFooter from '../comments/CommentsFooter'
import {canAccessSomeTeamAssignment, canManageAccountsAndPermissions, getLoggedInUser} from '../../loggedInUser/selectors'
import {connect} from '../../redux/utils'
import {bindActionCreators} from 'redux'
import {closeProjectPanel, commentsServiceActions, copyProjectAction, updateNewCommentText} from './actions'
import {
    canMoveProject,
    canReopenProject,
    getOpenProjectId,
    getProjectNewComment,
    isAllTasksAssigned,
    isSendingComment,
    isShowNewCommentInput
} from './selectors'
import TabsController from "../TabsController"
import {getEditableCustomerIds, getEditableCustomerIdsWithExcludeSelf, getViewerSettings} from '../../taskManagement/common/selectors'
import InformationBlock from '../../components/informationBlock/InformationBlock'
import CopySettingsBlock from '../components/CopySettingsBlock'
import {getItemsForCopyProjectSettingsBlock} from '../components/utils'
import {isBTYEnabled, isESTEnabled, isTTAEnabled, isTWSEnabled, isURAEnabled, isWASEnabled} from '../../features/selectors'
import {getFakeUpdateAuditAction} from '../utils'
import MoveToArchivedConfirmationDialog from '../MoveToArchivedConfirmationDialog'
import {getFirstCompletedWorkflowStatus} from '../../workflowStatus/selectors'

export class ProjectPanel extends TemplateView {
    constructor({
        updateDescription = () => {},
        saveComment = () => {},
        saveEditingComment = () => {},
        toggleNewCommentInput = () => {},
        updateNewCommentText = () => {},
        onPanelClose = () => {},
        setAllTasksAssigned = () => {},
        copyProject = () => {},
    }) {
        super();
        this.isBlockedDelete = false;

        this.actions = {
            updateDescription,
            saveComment,
            saveEditingComment,
            toggleNewCommentInput,
            updateNewCommentText,
            onPanelClose,
            setAllTasksAssigned,
            copyProject,
        }

        this.state = {
            currentTabKey: ProjectPanelTabs.DETAILS_TAB,
            loggedInUser: null,

            id: null,
            name: "",
            description: "",

            active: false,
            readOnly: false,
            allTasksAssigned: false,

            customerName: '',

            projectSpentTimeValues: null,
            workflowStatuses: [],
            defaultCompletedStatus: {},

            assignedUsersData: null,
            assignedUsersDataForManagers: {
                userGroupsEnabled: false,
                timeZoneGroupsEnabled: false,
                users: [],
                userGroups: [],
                timeZoneGroups: [],
                canModifyAny: false,
                assignButtonVisible: false,
            },

            deleteData: {},
            viewerSettings: {
                hasEditHierarchyRight: false,
                hasAccessToAllManagementScope: false
            },
            customersManagementAssignments: [],
            sendingComment: false,
            toggleNewCommentInput: false,
            newCommentText: '',

            copyMoveSelectorCustomersIds: {},
            manageableCustomersIds: {},
            canReopenProject: false,
            canMoveProject: true,

            isURAEnabled: false,
            isBTYEnabled: false,
            isESTEnabled: false,
            isTWSEnabled: false,
            isWASEnabled: false,

            canManageAccountsAndPermissions: false,
            hasSomeTeamAssignment: false,
        };

        this.onStatePropertyChanged('currentTabKey', this._handleTabSwitched)
        this.onAnyStatePropertyChanged([
            'name',
            'description',
            'active',
            'readOnly',
            'projectSpentTimeValues',
            'workflowStatuses',
            'assignedUsersDataForManagers',
            'assignedUsersData',
            'deleteData',
            'viewerSettings',
            'hasEditHierarchyRight',
            'hasAccessToAllManagementScope',
            'customersManagementAssignments',
            'canReopenProject',
            'canMoveProject',
        ], () => {
            this.updateView()
        });

        this.onStatePropertyChanged('loggedInUser', loggedInUser => {
            this.commentsFooter.setState({loggedInUser})
        })

        this.onStatePropertyChanged('id', id => {
            if (id !== null) {
                const selectedKey = this.state.currentTabKey
                if (selectedKey === ProjectPanelDialogs.MOVE_DIALOG ||
                    selectedKey === ProjectPanelDialogs.COPY_DIALOG ||
                    selectedKey === ProjectPanelDialogs.DELETE_DIALOG ||
                    selectedKey === ProjectPanelDialogs.ARCHIVE_DIALOG) {
                    this.openLastSelectedTab()
                }
            }
        })

        this.onStatePropertyChanged('sendingComment', sendingComment => {
            this.commentsFooter.setState({sending: sendingComment})
        })

        this.onStatePropertyChanged('showNewCommentInput', showNewCommentInput => {
            this.commentsFooter.setState({showNewCommentInput})
        })

        this.onStatePropertyChanged('newCommentText', newCommentText => {
            this.commentsFooter.setState({commentText: newCommentText})
        })

        this.onAnyStatePropertyChanged(['allTasksAssigned', 'isWASEnabled'], ({allTasksAssigned, isWASEnabled}) => {
            this.commentsFooter.toggle(allTasksAssigned)

            this.header.$tabs[ProjectPanelTabs.DETAILS_TAB].toggle(allTasksAssigned)
            this.header.$tabs[ProjectPanelTabs.ASSIGNED_USERS_TAB].toggle(isWASEnabled && allTasksAssigned)
            this.header.$tabs[ProjectPanelTabs.MANAGERS_TAB].toggle(allTasksAssigned)

            if (!allTasksAssigned || !this.lastSelectedTabKey) {
                this.openTabByKey(ProjectPanelTabs.DETAILS_TAB)
            } else {
                this.openLastSelectedTab()
            }

            this.buttons.get(ProjectPanelTabs.ASSIGNED_USERS_TAB).toggle(isWASEnabled && allTasksAssigned)
        })

        this.onAnyStatePropertyChanged(['copyMoveSelectorCustomersIds'], ({copyMoveSelectorCustomersIds}) => {
            this.moveToDialog.setCustomersToMove(copyMoveSelectorCustomersIds)
            this.copyToDialog.setCustomersToMove(copyMoveSelectorCustomersIds)
        })

        this.onAnyStatePropertyChanged(
            [
                'canManageAccountsAndPermissions',
                'isBTYEnabled',
                'isESTEnabled',
                'isTWSEnabled',
                'isWASEnabled',
                'hasSomeTeamAssignment'
            ], () => {
                this.copySettingsBlock.setState(
                    getItemsForCopyProjectSettingsBlock(
                        this.state.canManageAccountsAndPermissions,
                        this.state.isBTYEnabled,
                        this.state.isESTEnabled,
                        this.state.isTWSEnabled,
                        this.state.isWASEnabled,
                        this.state.hasSomeTeamAssignment,
                    )
                )
            })

        this.onAnyStatePropertyChanged(['isURAEnabled', 'isBTYEnabled', 'isTTAEnabled'], ({isURAEnabled, isBTYEnabled, isTTAEnabled}) => {
            this.tabs.get(ProjectPanelTabs.MANAGERS_TAB).setState({
                isURAEnabled,
                isBTYEnabled,
                isTTAEnabled
            })
        })

        this.onStatePropertyChanged('readOnly', (readOnly) => {
            this.assignedUsersEditorContainer.setState({
                hideAssignButton: readOnly,
            })
        })

        this.onStatePropertyChanged('isWASEnabled', () => this._updateDialogsInfo())

        this.onStatePropertyChanged('isTWSEnabled', (isTWSEnabled) => this.archivingConfirmation.setState({isTWSEnabled: isTWSEnabled}))

        this.updateOnInit = false
    }

    templateHtml() {
        return "<div class='taskManagement_projectPanel'>" +
               "  <div class='headerBlock'/>" +
               "    <div class='content_projectPanel'/>" +
               "    <div class='commentsFooterBlock'/>" +
               "</div>";
    }

    afterRender() {
        this.$header = this.find('.headerBlock');
        this.$content = this.find(".content_projectPanel");
        this.header = new ProjectPanelHeader(this.find(".headerBlock"), this.$el).init();
        this.detailsTab = new ProjectPanelContent({
            updateDescription: this.actions.updateDescription,
            refreshScrollCb: () => this.detailsTabScrollable.forceUpdate(),
            scrollToElementCb: ($el, pos) => this.detailsTabScrollable.scrollToElementVertical($el, pos)
        });
        this.detailsTabScrollable = new ScrollableContainer(null, this.detailsTab, {
            needRefreshOnResize: true,
            containerClass: 'projectPanelContentWrapper'
        })
        this.detailsTabScrollable.init(this.$content)

        const assignedUsersEditor = new LoadingContainer({
            contentComponent: new AssignedUsersEditor({
                onUserDelete: userData => this.trigger("assignedUserDelete", {userId: userData.id}),
                onAssignedUsersChange: ({addedUserIds, removedUserIds}) => this.trigger("assignedUsersChange", {addedUserIds, removedUserIds}),
                titleMessageKey: "assigned_users_editor.project.title",
                userSubtitleGenerator: (user) => {
                    if (user.hasAllAssignments) {
                        return messageResource.getMessage("assigned_users_editor.project.has_all_assignments")
                    } else if (user.hasCustomerAssignment) {
                        return messageResource.getMessage("assigned_users_editor.project.has_customer_assignment")
                    }
                },
                managersMessageKey: "assigned_users_editor.project.managers_count",
                canEditManagers: false,
                addUsersMessageKey: "assigned_users_editor.add_title",
                emptyListMessageKey: "assigned_users_editor.project.empty_list",
                showPermissionIcons: false,
                usersSelectorTitle: messageResource.getMessage("assigned_users_editor.project.users_selector_title"),
                renderUserSelectorToContent: true,
                refreshScrollCb: () => assignedUsersEditorScrollable.forceUpdate(),
                checkIfCanModify: user => !user.hasManageAssignment,
                getListDisabledTooltipText: user => this._getDisabledTooltipTextAssugnedUsersEditor(user),
                getSelectorDisabledTooltipText: user => this._getDisabledTooltipTextAssignedUsersSelector(user),
            }),
            containerClass: "assignedUsersTab panelTab"
        });

        const assignedUsersEditorScrollable = new ScrollableContainer(null, assignedUsersEditor, {
            needRefreshOnResize: true,
            containerClass: 'assignedUsersScrollableContainer',
        })

        this.assignedUsersEditorContainer = new AssignedUsersEditorContainer({
            assignedUsersEditor: assignedUsersEditorScrollable,
            $tabTitle: this.header.$assignedUsersTabTitle,
            tabTitleMessageKey: "task.edit_panel.tabs.assigned_users_with_count"
        }).init();

        const managersEditor = new LoadingContainer({
            contentComponent: new AssignedUsersEditor({
                onUserDelete: userData => this.trigger("managerDelete", {userData}),
                onAssignedUsersChange: ({addedUserIds, removedUserIds}) => this.trigger("managersChange", {addedUserIds, removedUserIds}),
                titleMessageKey: "assigned_users_editor.managers.project.title",
                userSubtitleGenerator: (user) => {
                    if (user.hasAllAssignments) {
                        return messageResource.getMessage("assigned_users_editor.managers.project.has_all_assignments")
                    } else if (user.hasCustomerAssignment) {
                        return messageResource.getMessage("assigned_users_editor.managers.project.has_customer_assignment")
                    } else if (user.hasAllFutureTasksOfProjectAssignment) {
                        return messageResource.getMessage("assigned_users_editor.managers.project.has_only_tasks_assignment")
                    }
                },
                addUsersMessageKey: "assigned_users_editor.managers.add_title",
                showPermissionIcons: true,
                usersSelectorTitle: messageResource.getMessage("assigned_users_editor.managers.project.users_selector_title"),
                renderUserSelectorToContent: true,
                refreshScrollCb: () => managersEditorScrollable.forceUpdate(),
                checkIfCanModify: user => {
                    return !user.hasAllAssignments && !user.hasCustomerAssignment && !user.hasAllFutureProjectsOfCustomerAssignment
                },
                getListDisabledTooltipText: user => this._getDisabledTooltipTextManagersEditor(user),
                getSelectorDisabledTooltipText: user => this._getDisabledTooltipTextManagersEditor(user),
            }),
            containerClass: "managersTab panelTab"
        });

        const managersEditorScrollable = new ScrollableContainer(null, managersEditor, {
            needRefreshOnResize: true,
            containerClass: 'assignedUsersScrollableContainer',
        })

        this.managersEditorContainer = new AssignedUsersEditorContainer({
            assignedUsersEditor: managersEditorScrollable,
            $tabTitle: this.header.$managersTabTitle,
            tabTitleMessageKey: "task.edit_panel.tabs.managers_with_count"
        }).init();

        this._initMoveToDialog()
        this._initCopyToDialog()

        this.archiveDialog = new ArchiveProjectDialog(null)
        this.archiveDialogScrollable = new ScrollableContainer(null, this.archiveDialog, {needRefreshOnResize: true}).init(this.$content);

        this.deleteDialog = new DeleteProjectPopupConfirmationDialog(
            null,
            () => $(this).trigger("cancelDelete"),
            (revokeStatuses) => $(this).trigger("delete", revokeStatuses)
        )
        this.deleteDialogScrollable = new ScrollableContainer(null, this.deleteDialog, {needRefreshOnResize: true}).init(this.$content);

        this.tabs = new Map([
            [ProjectPanelTabs.DETAILS_TAB, this.detailsTabScrollable],
            [ProjectPanelTabs.ASSIGNED_USERS_TAB, assignedUsersEditorScrollable.init(this.$content)],
            [ProjectPanelTabs.MANAGERS_TAB, managersEditorScrollable.init(this.$content)],
            [ProjectPanelDialogs.MOVE_DIALOG, this.moveToDialogScrollable],
            [ProjectPanelDialogs.COPY_DIALOG, this.copyToDialogScrollable],
            [ProjectPanelDialogs.DELETE_DIALOG, this.deleteDialogScrollable],
            [ProjectPanelDialogs.ARCHIVE_DIALOG, this.archiveDialogScrollable],
        ])

        this.tabs.forEach(($tab, tabKey) => {
            $tab.hide()
        })

        this.tabsController = new TabsController({
            tabs: this.tabs,
        }).init()

        this.buttons = new Map([
            [ProjectPanelTabs.DETAILS_TAB, this.header.$tabs[ProjectPanelTabs.DETAILS_TAB]],
            [ProjectPanelTabs.ASSIGNED_USERS_TAB, this.header.$tabs[ProjectPanelTabs.ASSIGNED_USERS_TAB]],
            [ProjectPanelTabs.MANAGERS_TAB, this.header.$tabs[ProjectPanelTabs.MANAGERS_TAB]],
            [ProjectPanelDialogs.DELETE_DIALOG, this.header.actions.menu.$delete],
            [ProjectPanelDialogs.MOVE_DIALOG, this.header.actions.menu.$move],
            [ProjectPanelDialogs.COPY_DIALOG, this.header.actions.menu.$copy],
        ])

        this.buttons.forEach(($button, key) => {
            $button.click(() => {
                if (key !== ProjectPanelDialogs.DELETE_DIALOG && key !== ProjectPanelDialogs.MOVE_DIALOG
                    || key === ProjectPanelDialogs.DELETE_DIALOG && !this.isBlockedDelete
                    || key === ProjectPanelDialogs.MOVE_DIALOG && this.state.canMoveProject) {
                    this.openTabByKey(key)
                }
            })
        })

        this.commentsFooter = new CommentsFooter({
            onCommentTextChange: this.actions.updateNewCommentText,
            onShowInputChanged: this.actions.toggleNewCommentInput,
            onCommentAdded: this.actions.saveComment,
            refreshScrollCb: () => {
                this.detailsTabScrollable.performIfScrollToBottom(() => {
                    this.detailsTabScrollable.forceUpdate()
                    this.detailsTabScrollable.scrollToBottom()
                })
                this.detailsTabScrollable.forceUpdate()
            }
        }).init(this.find('.commentsFooterBlock'))
    }

    _onProjectMove = (customer) => {
        if (customer.archived && this.state.active) {
            this.moveToDialogScrollable.hide()
            this.archivingConfirmationScrollable.show()
            this.archivingConfirmationScrollable.setState({
                customer: customer,
                withRestoreOption: !!this.state.manageableCustomersIds[customer.id],
                completeOptionSelected: true,
                workflowStatusId: this.state.defaultCompletedStatus.id,
            })
        } else {
            this.trigger("move", {customer: customer, forceReopen: false, newWorkflowStatusId: null})
        }
    }

    _initCopyToDialog() {
        this.copySettingsBlock = new CopySettingsBlock({
            additionalClass: 'copyProject',
            ...getItemsForCopyProjectSettingsBlock(this.state.canManageAccountsAndPermissions,
                this.state.isBTYEnabled,
                this.state.isESTEnabled,
                this.state.isTWSEnabled,
                this.state.isWASEnabled,
            )
        })

        this.copyToDialogInfoBlock = new InformationBlock()

        this.copyToDialog = new MoveToDialog({
            mode: MoveToDialog.Mode.CUSTOMER,
            titleMessageKey: "task.list.copy_to.project.title",
            buttonMessageKey: "edit_panel.action.copy",
            onMoveCb: (customer, project, settings) => {
                this.actions.copyProject(customer.id, settings, () => this.openLastSelectedTab())
            },
            onCancelCb: () => this.openLastSelectedTab(),
            infoBlock: this.copyToDialogInfoBlock,
            settingsBlock: this.copySettingsBlock,
        })
        this.copyToDialog.setShowArchived(false)
        this.copyToDialogScrollable = new ScrollableContainer(null, this.copyToDialog, {needRefreshOnResize: true}).init(this.$content)
    }

    _initMoveToDialog() {
        this.moveToDialogInfoBlock = new InformationBlock({
            title: messageResource.getMessage('task.list.move_to.project.info_title'),
        })

        this.moveToDialog = new MoveToDialog({
            mode: MoveToDialog.Mode.CUSTOMER,
            titleMessageKey: "task.list.move_to.project.title",
            buttonMessageKey: "edit_panel.action.move",
            infoBlock: this.moveToDialogInfoBlock,
            onMoveCb: this._onProjectMove,
            onCancelCb: () => this.openLastSelectedTab(),
        })
        this.moveToDialog.setState({showArchived: true})
        this.moveToDialogScrollable = new ScrollableContainer(null, this.moveToDialog, {needRefreshOnResize: true}).init(this.$content)

        this._initMoveToArchiveConfirmationDialog()
    }

    _initMoveToArchiveConfirmationDialog() {
        this.archivingConfirmation = new MoveToArchivedConfirmationDialog({
            confirmCallback: ({customer, withRestore, workflowStatusId}) => {
                this.archivingConfirmationScrollable.hide()
                this.trigger("move", {customer: customer, forceReopen: withRestore, newWorkflowStatusId: workflowStatusId})
            },
            cancelCallback: () => {
                this.archivingConfirmationScrollable.hide()
                const moveToDialogState = this.moveToDialog.getState()
                this.moveToDialogScrollable.show()
                this.moveToDialog.setState(moveToDialogState)
            },
        })
        this.archivingConfirmation.setState({
            workflowStatusId: this.state.defaultCompletedStatus.id,
            title: messageResource.getMessage("task.list.move_to.project.archive_confirmation.title"),
            multiOptionDescription: messageResource.getMessage("task.list.move_to.project.archive_confirmation.description"),
            archiveText: messageResource.getMessage("task.list.move_to.project.archive_confirmation.complete_with_status"),
            restoreText: messageResource.getMessage("task.list.move_to.project.archive_confirmation.restore"),
        })

        this.archivingConfirmationScrollable = new ScrollableContainer(null, this.archivingConfirmation, {needRefreshOnResize: true}).init(this.$content)
        this.archivingConfirmationScrollable.hide()
    }

    _updateDialogsInfo() {
        this.moveToDialogInfoBlock.setState({
            paragraphs: [
                messageResource.getMessage(this.state.isWASEnabled ? 'task.list.move_to.project.info_paragraph1'
                                                                   : 'task.list.move_to.project.info_paragraph1_was_off'),
                messageResource.getMessage(this.state.isWASEnabled ? 'task.list.move_to.project.info_paragraph2'
                                                                   : 'task.list.move_to.project.info_paragraph2_was_off'),
            ],
        })

        this.copyToDialogInfoBlock.setState({
            paragraphs: [
                messageResource.getMessage(this.state.isWASEnabled ? 'task.list.copy_to.project.info_paragraph'
                                                                   : 'task.list.copy_to.project.info_paragraph_was_off'),
            ],
        })
    }

    _getDisabledTooltipTextManagersEditor(user) {
        let msg = messageResource.getMessage(
            'assigned_users_editor.managers.disabled_tooltip',
            [
                messageResource.getMessage('common.project'),
                user.firstName,
            ]
        )

        if (user.hasAllAssignments) {
            msg += " " + messageResource.getMessage('assigned_users_editor.managers.disabled_tooltip.entire_scope')
        }  else if (user.hasAllFutureProjectsOfCustomerAssignment) {
            msg += " " + messageResource.getMessage(
                'assigned_users_editor.managers.disabled_tooltip.all_existing_and_future_items_assignment',
                [
                    messageResource.getMessage('common.projects'),
                    messageResource.getMessage('common.customer'),
                ]
            )
        } else if (user.hasCustomerAssignment) {
            msg += " " + messageResource.getMessage(
                'assigned_users_editor.managers.disabled_tooltip.entire_item_assignment',
                [messageResource.getMessage('common.customer')],
            )
        }
        return msg
    }

    _getDisabledTooltipTextAssugnedUsersEditor(user) {
        return messageResource.getMessage(
            'panel.common.cannot_unassign_user.tooltip',
            [
                messageResource.getMessage('common.projects'),
                user.firstName
            ])
    }

    _getDisabledTooltipTextAssignedUsersSelector(user) {
        return messageResource.getMessage(
            'assigned_users_editor.work.disabled_tooltip.user_manages_item',
            [
                messageResource.getMessage('common.project'),
            ])
    }

    _handleTabSwitched = (selectedKey, previousKey) => {
        this.archivingConfirmationScrollable.hide()
        this.tabsController.setState({selectedTabKey: selectedKey})

        let prevButton = this.buttons.get(previousKey)
        if (prevButton) prevButton.toggleClass('selected', false)
        let button = this.buttons.get(selectedKey)
        if (button) button.toggleClass('selected', true)

        if (selectedKey !== ProjectPanelDialogs.MOVE_DIALOG && selectedKey !== ProjectPanelDialogs.COPY_DIALOG &&
            selectedKey !== ProjectPanelDialogs.DELETE_DIALOG && selectedKey !== ProjectPanelDialogs.ARCHIVE_DIALOG) {
            this.lastSelectedTabKey = selectedKey
        }

        this.commentsFooter.toggle(selectedKey === ProjectPanelTabs.DETAILS_TAB)
        if (selectedKey !== ProjectPanelTabs.DETAILS_TAB) {
            this.actions.saveEditingComment()
        }

        this.tabs.get(selectedKey).update()
    }

    openLastSelectedTab() {
        this.openTabByKey(this.lastSelectedTabKey)
    }

    openTabByKey(key) {
        this.setState({currentTabKey: key})
    }

    onDependantDataUpdate(event) {
        _.each(this.listeners, function(listener) {listener.onDependantDataUpdate(event)});
    }

    updateView() {
        this.projectId = this.state.id;

        this.header.setState({
            projectName: this.state.name,
            customerName: this.state.customerName,
            readOnly: this.state.readOnly,
            blockedDueToLockedTime: this.state.deleteData.blockedDueToLockedTime,
            blockedDueToUnavailableToModifyTimeTrack: this.state.deleteData.blockedDueToUnavailableToModifyTimeTrack,
            canManageAllUsersWithoutAutoApproved: this.state.deleteData.canManageAllUsersWithoutAutoApproved,
        });

        let deletedData = this.state.deleteData;

        this._setIsBlockedDelete(deletedData)

        if(!this.isBlockedDelete) {
            this._initDeleteDialog(this.state.name, deletedData);
        }

        this.detailsTabScrollable.setState({
            active: this.state.active,
            readOnly: this.state.readOnly,
            description: this.state.description,
            projectSpentTimeValues: this.state.projectSpentTimeValues,
            workflowStatuses: this.state.workflowStatuses,
            canReopenProject: this.state.canReopenProject,
        });

        if (this.state.assignedUsersData)
            applyDataToAssignedUsersEditor(this.assignedUsersEditorContainer, this.state.assignedUsersData)

        applyDataToAssignedUsersEditor(this.managersEditorContainer, this.state.assignedUsersDataForManagers)
        this.managersEditorContainer.setState({
            hideAssignButton: !this.state.assignedUsersDataForManagers.canModifyAny
        })
    }

    setFakeLastAudit() {
        this.detailsTab.updateLastAudit(getFakeUpdateAuditAction(this.state.loggedInUser))
    }

    _setIsBlockedDelete(deletedData) {
        this.isBlockedDelete = deletedData.blockedDueToLockedTime || deletedData.blockedDueToUnavailableToModifyTimeTrack
    }

    _initDeleteDialog(name, data) {
            this.deleteDialog.setState({
                entityName: name,
                entitiesToDeleteCount: 1,
                entitiesBlocked: 0,
                entitiesBlockedCount: 0,
                entitiesBlockedDueToLockedTimeCount: 0,
                entitiesBlockedDueToUnavailableToModifyTimeTrackCount: 0,
                entitiesWithManagerTimeTrackCount: data.projectHasManagerTimeTrack ? 1 : 0,
                entitiesWithOtherUsersTimeTrackCount: data.projectHasOtherUsersTimeTrack ? 1 : 0,
                entitiesWithManagerApprovedTimeTrackCount: data.projectHasManagerApprovedTimeTrack ? 1 : 0,
                entitiesWithOtherUsersApprovedTimeTrackCount: data.projectHasOtherUsersApprovedTimeTrack ? 1 : 0,
                hasManagerApprover: data.hasManagerApprover
            });
    }

    onHide() {
        this.header.actions.hideMenu();
        this.detailsTab.details.hideSelectors();
        this.actions.saveEditingComment()
        this.actions.onPanelClose()
        this.archivingConfirmationScrollable.hide()
    }

    onShow() {
        this.detailsTab.details.setSelectorsDisabled(false);
        this.detailsTabScrollable.forceUpdate()
    }

    onScroll() {
        super.onScroll();
        this.detailsTab.details.hideAuditHistoryMenu();
    }

    getTabView(tabKey) {
        return this.tabs.get(tabKey)
    }

    getSelectedTabKey() {
        return this.state.currentTabKey;
    }
}

export default connect(
    state => ({
        loggedInUser: getLoggedInUser(state),
        sendingComment: isSendingComment(state),
        showNewCommentInput: isShowNewCommentInput(state),
        newCommentText: getProjectNewComment(state),
        id: getOpenProjectId(state),
        viewerSettings: getViewerSettings(state),
        allTasksAssigned: isAllTasksAssigned(state),
        copyMoveSelectorCustomersIds: getEditableCustomerIdsWithExcludeSelf(state),
        manageableCustomersIds: getEditableCustomerIds(state),
        canReopenProject: canReopenProject(state),
        canMoveProject: canMoveProject(state),
        canManageAccountsAndPermissions: canManageAccountsAndPermissions(state),
        isBTYEnabled: isBTYEnabled(state),
        isURAEnabled: isURAEnabled(state),
        isTWSEnabled: isTWSEnabled(state),
        isESTEnabled: isESTEnabled(state),
        isWASEnabled: isWASEnabled(state),
        isTTAEnabled: isTTAEnabled(state),
        defaultCompletedStatus: getFirstCompletedWorkflowStatus(state),
        hasSomeTeamAssignment: canAccessSomeTeamAssignment(state),
    }),
    dispatch => ({
        saveComment: bindActionCreators(commentsServiceActions.saveComment, dispatch),
        saveEditingComment: bindActionCreators(commentsServiceActions.saveEditingComment, dispatch),
        onPanelClose: bindActionCreators(closeProjectPanel, dispatch),
        toggleNewCommentInput: bindActionCreators(commentsServiceActions.toggleNewCommentInput, dispatch),
        updateNewCommentText: bindActionCreators(updateNewCommentText, dispatch),
        copyProject: bindActionCreators(copyProjectAction, dispatch),
    })
)(ProjectPanel)

export const ProjectPanelTabs = {
    NONE: "none",
    DETAILS_TAB: 'details',
    ASSIGNED_USERS_TAB: 'assignedUsers',
    MANAGERS_TAB: 'managers'
}

export const ProjectPanelDialogs = {
    NONE: 'none',
    COPY_DIALOG: 'copy',
    MOVE_DIALOG: 'move',
    DELETE_DIALOG: 'delete',
    ARCHIVE_DIALOG: 'archive'
}



// WEBPACK FOOTER //
// ./web/js/panels/project/ProjectPanel.js